import 'regenerator-runtime/runtime'

import { initContract, login, logout, isAccountExist } from './utils'

import getConfig from './config'
import { transfer } from 'near-api-js/lib/transaction';
const { networkId } = getConfig(process.env.NODE_ENV || 'development')

// global variable used throughout
let tokenInfo = null;
let tokenBalance = 0;
let tokenSupply = 0;

// const submitButton = document.querySelector('form button');
window.registerToken = registerToken;
window.claimToken = claimToken;

async function transferToken() {
    try {
        let reciever = document.querySelector(`#transfer-receiver`).value;
        let amount = Number(document.querySelector(`#transfer-amount`).value);
        if (!await isAccountExist(reciever)) {
            alert(`The reciever '${reciever}' is not existed. Please enter the other reciever!`);
            return;
        }
        if (amount<=0) {
            alert(`The amount is invalid. Please re-enter the amount!`);
            return;
        }
        if (amount>tokenBalance) {
            alert(`You have not enough token for transfer!!!`);
            return;
        }
        amount = Number(amount*10**tokenInfo.decimals).toFixed();
        await window.contract.ft_transfer({
            receiver_id: reciever,
            amount: amount
        }, (60*10**12).toFixed(), 1);
    } catch(ex) {
        console.error("Transfer token error", ex);
        alert(`Unable to transfer token!!!`);
    }
}

async function registerToken() {
    try {
        await window.contract.storage_deposit({}, (60*10**12).toFixed(), "1250000000000000000000");
    } catch(ex) {
        console.error("Register token error", ex);
        alert(`Unable to register token!!!`);
    }
}

async function claimToken() {
    try {
        await window.contract.claim({});
    } catch(ex) {
        console.error("Claim token error", ex);
        alert(`Unable to claim token!!!`);
    }
}

async function updateTokenInfo() {
    tokenInfo = await window.contract.ft_metadata({});
    if (tokenInfo) {
        // Supply
        let supply = await window.contract.ft_total_supply({});
        if (supply==null) tokenSupply = 0;
        else {
            tokenSupply = supply/10**tokenInfo.decimals;
        }

        // Balance
        let balance = await window.contract.ft_balance_of({account_id: window.accountId});
        if (balance==null) tokenBalance = 0;
        else {
            tokenBalance = balance/10**tokenInfo.decimals;
        }
    }
}

async function updateTokenInfoUi() {
    if (!tokenInfo) {
        await updateTokenInfo();
    }
    console.log("Token Info", tokenInfo);
    if (!tokenInfo) return;

    document.querySelector("#tokenName").innerHTML = `${tokenInfo.name} (${tokenInfo.symbol})`;
    // document.querySelector("#tokenImage").src = tokenInfo.icon;

    document.querySelector("#yourTokenBalance").innerHTML = `${tokenBalance}`;
    document.querySelector("#tokenTotalSupply").innerHTML = `${tokenSupply}`;
    if (tokenBalance>0) {
        document.querySelector("#linkRegisterToken").style.display = "none";
        
    }
}

document.querySelector('#sign-in-button').onclick = login
document.querySelector('#sign-out-button').onclick = logout

// Display the signed-out-flow container
function signedOutFlow() {
    document.querySelector('#signed-out-flow').style.display = 'block'
}

// Displaying the signed in flow container and fill in account-specific data
function signedInFlow() {
    document.querySelector('#signed-in-flow').style.display = 'block'

    document.querySelectorAll('[data-behavior=account-id]').forEach(el => {
        el.innerText = window.accountId
    })

    // populate links in the notification box
    const accountLink = document.querySelector('[data-behavior=notification] a:nth-of-type(1)')
    accountLink.href = accountLink.href + window.accountId
    accountLink.innerText = '@' + window.accountId
    const contractLink = document.querySelector('[data-behavior=notification] a:nth-of-type(2)')
    contractLink.href = contractLink.href + window.contract.contractId
    contractLink.innerText = '@' + window.contract.contractId

    // update with selected networkId
    accountLink.href = accountLink.href.replace('testnet', networkId)
    contractLink.href = contractLink.href.replace('testnet', networkId)

    updateTokenInfoUi();
}

document.querySelector('#transferForm').onsubmit = async (event) => {
    event.preventDefault()

    let btnTransferToken = document.querySelector("#btnTransferToken");
    btnTransferToken.disabled = true;
    // Get and check data
    await transferToken();    

    btnTransferToken.disabled = false;
}

// `nearInitPromise` gets called on page load
window.nearInitPromise = initContract()
    .then(() => {
        if (window.walletConnection.isSignedIn()) signedInFlow()
        else signedOutFlow()
    })
    .catch(console.error)
